import { type VariantProps, cva } from "class-variance-authority";
import type { ReactNode } from "react";
import { cn } from "../lib/cn";

export const keyValueVariants = cva("flex", {
	variants: {
		direction: {
			vertical: "flex-col gap-0.5",
			horizontal: "flex-row items-center gap-2",
		},
	},
	defaultVariants: {
		direction: "vertical",
	},
});

export interface KeyValueProps extends VariantProps<typeof keyValueVariants> {
	label: ReactNode;
	value: ReactNode;
	className?: string;
	labelClassName?: string;
	valueClassName?: string;
}

function KeyValue({
	label,
	value,
	direction,
	className,
	labelClassName,
	valueClassName,
}: KeyValueProps): ReactNode {
	return (
		<div className={cn(keyValueVariants({ direction }), className)}>
			<dt
				className={cn(
					"text-xs font-medium text-mutedForeground",
					labelClassName,
				)}
			>
				{label}
			</dt>
			<dd className={cn("text-sm text-foreground", valueClassName)}>{value}</dd>
		</div>
	);
}
KeyValue.displayName = "KeyValue";

export default KeyValue;
export { KeyValue };
